<template>
  <div class="content_index">
    <div class="kv_box">
      <div class="kv">
        <div class="swiper-container swiper1">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in kvList"
              :key="index"
            >
              <router-link to="/Contact-us" ><img class="w100-1" :src="item.show_img" alt="" /></router-link
                >
             <!-- <div class="text_des">
                Deliver high wear performance, <br />
                Reduce your maintenance cost,<br />
                Bring down your shutdown time.
                Learn More
              </div> -->
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="tips2">
      <!-- <img src="@/assets/images/index/tips2_bg.jpg" alt="" class="w100"> -->
      <div class="container">
        <div class="text_box">
          <h3 class="custom-title">About Us</h3>
          <p>
            HISAN (Tianjin) Co., Ltd. is an integrated enterprise dedicated to the research & development, production, and sales of advanced wear resistant materials. Operating from a modern facility spanning 16,000 square meters with a team of over 180 employees, including more than 20 technical R&D specialists, HISAN is equipped with state-of-the-art manufacturing equipment and proprietary processes. Our expert technical team is committed to delivering premium wear resistant solutions and exceptional service to our global customers.<br>
            Benefiting from strong in-house production and R&D capabilities, HISAN achieves an annual output of 26,000 tons of wear resistant materials. We have developed multiple comprehensive production lines, offering a complete product series that includes Fused Alloy Smooth Surface CCO Plates, CCO Plate, Welding Wire, Overlay Wear Pipe, Wear Parts, and Overlay Welding & Repair services. </p>
          <ul>
            <li>
              <p>Export Country</p>
              <div>
                <span
                  ><CountTo
                    ref="refcountofore1"
                    :duration="1000"
                    :start-val="_startVal"
                    :end-val="40"
                    :decimals="0"
                  ></CountTo
                  >+</span
                >
              </div>
            </li>
            <li>
              <p>Technicians & R&D</p>
              <div>
                <span
                  ><CountTo
                    ref="refcountofore2"
                    :duration="1000"
                    :start-val="_startVal"
                    :end-val="20"
                    :decimals="0"
                  ></CountTo
                  >+</span
                >
              </div>
            </li>
            <!-- <li>
							<p>Cooperative Client </p>
							<span><CountTo ref="refcountofore3" :duration="1000" :start-val="_startVal" :end-val="200" :decimals="0"></CountTo>+</span>
						</li> -->
            <li>
              <p>Area</p>
              <div>
                <span
                  ><CountTo
                    ref="refcountofore4"
                    :duration="1000"
                    :start-val="_startVal1"
                    :end-val="16000"
                    :decimals="0"
                  ></CountTo></span
                >m<sup>2</sup>
              </div>
            </li>
          
          </ul>
          
        </div>
        <video class="video" ref="videoPlayer" src="@/assets/images/index/video.mp4" controls></video>
      </div>
    </div>
    <div class="tips3" v-if="vshow == true">
      <div class="container">
        <h3 class="custom-title white">Product Range</h3>
        <ul class="tips3List">
          <li
            v-for="(item, index) in tips3List"
            :key="index"
            @click="golinkto(item.linkurl)"
          >
            <img :src="item.image" alt="" class="tisp3_img" />
            <div class="text_bottom">
              <div class="tips3_text">
                <h4>{{ item.title }}</h4>
                <p>{{ item.overview }}</p>
              </div>
              <div class="buttom" @click="golinkto(item.linkurl)">
                <img src="@/assets/images/index/jt_r.png" alt="" />
                <span>View Products</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tips_boxz">
      <div class="tips4">
        <div class="container">
          <div class="text_box">
            <h3 class="custom-title">Applications</h3>

            <div class="swiper-container swiper5">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  @click="golink(item.show_link)"
                  v-for="(item, index) in tips4List"
                  :key="index"
                >
                  <img :src="item.show_img" alt="" class="w100" />
                  <p>{{ item.show_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips5">
        <div class="container">
          <h3 class="custom-title">Equipment Display</h3>
          <div class="img_box">
            <!-- <div class="tips5_1 tips5_img">
							<div class="swiper-container swiper2">
								<div class="swiper-wrapper">
									<div class="swiper-slide"  v-for="(item,index) in tipslunbo" :key="index" v-if="item.sort<10">
									   <img class="w100" :src="item.show_img" alt=""/>
                                       <p>{{item.show_name}}</p>
									</div>
									
								</div>
								
							</div>
							
						</div> -->
            <div class="tips5_1">
              <p>
                <router-link to="/Production-capacity"
                  >- Production capacity</router-link
                >
              </p>
              <p>
                <router-link to="/Research-ability"
                  >- Research ability</router-link
                >
              </p>
              <router-link to="/contact" class="btn_contact"
                >Learn More</router-link
              >
            </div>
            <div class="tips5_2">
              <div class="tips5_img tips5_img_top">
                <p class="top-text">Production capacity</p>
                <div class="swiper-container swiper3">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in tipslunbo"
                      :key="index"
                      v-if="item.sort < 20 && item.sort > 10"
                    >
                      <img class="w100" :src="item.show_img" alt="" />
                    </div>
                  </div>
                </div>
                <p class="bottom-text">Production capacity</p>
              </div>
              <div class="tips5_img">
                <p class="top-text">Research ability</p>
                <div class="swiper-container swiper4">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in tipslunbo"
                      :key="index"
                      v-if="item.sort < 30 && item.sort > 20"
                    >
                      <img class="w100" :src="item.show_img" alt="" />
                    </div>
                  </div>
                </div>
                <p class="bottom-text">Research ability</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tips7">
        <div class="container">
          <div class="text_box">
            <h3 class="custom-title white">Our Honor</h3>
            <p>{{ HonorText }}</p>
            <div class="swiper-container swiper6">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in Honorlb"
                  :key="index"
                >
                  <img :src="item.show_img" alt="" class="w100 tips7-img" />
                  <!-- <p>{{item.show_name}}</p> -->
                </div>
              </div>
            </div>
            <a class="lear_more" href="/cco">Lear more</a>
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="tips6">
        <img
          src="@/assets/images/index/tips6_bg.jpg"
          alt=""
          class="w100"
          style="opacity: 0;"
        />
        <div class="container">
          <div class="text_box">
            <h3 class="custom-title">Why Choose Us?</h3>
            <ul class="text_box_list">
              <li v-for="(item, index) in tips6List" :key="index">
                <img :src="item.imgsrc" alt="" class="" />
                <div>
                  <h4>{{ item.name }}</h4>
                  <p>{{ item.text }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import CountTo from "vue-count-to";
import Swiper from "swiper";
import axios from "axios";
export default {
  components: {
    CountTo,
  },
  data() {
    return {
      vshow: false,
      startOnMount: false,
      _startVal: 0,
      HonorText: "",
      _startVal1: 10000,
      kvList: [],
      Honorlb: [],
      tips3List: [],
      tips4List: [],
      isExpanded: false,
      videoUrl: '',
      tips6List: [
        {
          imgsrc: require("@/assets/images/index/tips6_1.png"),
          name: "Persuit of Quality",
          text:
            "High quality is our obligation! Hisan's products are all produced under tightly controlled parameters and would be inspected before leaving our plants.",
        },
        {
          imgsrc: require("@/assets/images/index/tips6_2.png"),
          name: "Support Service",
          text:
            "Great Service is our mission! Hisan provides quick reactions to your queries within 24 hours. We are commited to providing exceptional customer support.",
        },
        {
          imgsrc: require("@/assets/images/index/tips6_3.png"),
          name: "Expertise",
          text:
            "We are a gorup of professional people with 10 years of extensive industry experience. Hisan assists its clients with proper material selection, industrial design and installation.",
        },
      ],
    };
  },
  methods: {
    golink(cid) {
      const routeUrl = this.$router.resolve({
        path: cid,
      });
      window.open(routeUrl.href, "_self");
    },
    
    golinkto(link) {
      const routeUrl = this.$router.resolve({
        path: link,
      });
      window.open(routeUrl.href, "_self");
    },
    handleScrollx() {
      const currentHeight = window.pageYOffset;
      console.log(currentHeight);
      if (currentHeight > 400) {
        this.$refs.refcountofore1.start();
        this.$refs.refcountofore2.start();
        // this.$refs.refcountofore3.start();
        this.$refs.refcountofore4.start();
        // this.starCount()
      }
    },
  },
  mounted() {
    var that = this;
    that.$emit("loaded");
    axios({
      method: "post",
      url: `${this.$apiYf}/indexlunboapi.php`,
      data: {
        cid: 1,
      },
      headers: { "Content-Type": "multipart/form-data" },
    }).then((res) => {
      if (res.data.error == 0) {
        that.kvList = res.data.lunboinfo;
        
        axios({
          method: "post",
          url: `${this.$apiYf}/anlistapi.php?catid=10`,

          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          that.tips3List = res.data.productc_list;
        });
        
        axios({
          method: "post",
          url: `${this.$apiYf}/indexlunboapi.php?cid=16`,

          headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
          that.tips4List = res.data.lunboinfo;
          axios({
            method: "post",
            url: `${this.$apiYf}/indexlunboapi.php?cid=17`,

            headers: { "Content-Type": "multipart/form-data" },
          }).then((res) => {
            that.tipslunbo = res.data.lunboinfo;
            that.vshow = true;

            axios({
              method: "post",
              url: `${this.$apiYf}/indexlunboapi.php?cid=22`,

              headers: { "Content-Type": "multipart/form-data" },
            }).then((res3) => {
              console.log(res3);
              
              let swiper6Option = {};
              if (
                navigator.userAgent.match(
                  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                )
              ) {
                console.log("手机");
                swiper6Option = {
                  loop: true,
                  autoplay: true,
                  spaceBetween: 15,
                  navigation: {
                    nextEl: ".tips7 .swiper-button-next",
                    prevEl: ".tips7 .swiper-button-prev",
                    clickable: true,
                  },
                  // autoHeight: true,
                  centeredSlides: true,
                  slidesPerView: 4,
                };
              } else {
                swiper6Option = {
                  loop: true,
                  autoplay: true,
                  spaceBetween: 15,
                  navigation: {
                    nextEl: ".tips7 .swiper-button-next",
                    prevEl: ".tips7 .swiper-button-prev",
                    clickable: true,
                  },
                  // autoHeight: true,
                  // centeredSlides: true,
                  slidesPerView: 5,
                };
              }
              that.HonorText = res3.data.show_text;
              that.Honorlb = res3.data.lunboinfo;
              that.$nextTick(() => {
                that.swiper6 = new Swiper(".swiper6", swiper6Option);
              });
            });
            that.$nextTick(() => {
              that.kvSwiper = new Swiper(".kv .swiper1", {
                effect: "fade",
                loop: false,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                pagination: {
                  el: ".kv .swiper-pagination",
                  clickable: true,
                },
                navigation: {
                  nextEl: ".kv .swiper-button-next",
                  prevEl: ".kv .swiper-button-prev",
                  clickable: true,
                },
                speed: 500,
                // height: 212,
                autoHeight: true,
                roundLengths: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                calculateHeight: true,
              });
              console.log(
                ($(".tips5_1").width() / 680) * 710,
                '($(".tips5_1").width() / 680) * 710,'
              );
              that.swiper2 = new Swiper(".swiper2", {
                loop: true,
                speed: 4000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                },
                mousewheel: true,
                direction: "vertical",
                height: ($(".tips5_1").width() / 680) * 710,
                autoHeight: true,
                centeredSlides: true,
                slidesPerView: 2,
              });
              let nowHeight = (($(".container").width() * 0.35) / 680) * 335;
              let swiper5Option = {
                loop: true,
                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                spaceBetween: 50,
                slidesPerView: 3,
                autoHeight: true,
                centeredSlides: true,
              };
              let isMobile = false
              if (
                navigator.userAgent.match(
                  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
                )
              ) {
                console.log("手机");
                nowHeight = 200;
                isMobile= true
                swiper5Option = {
                  loop: true,
                  autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                  },
                  // spaceBetween: 50,
                  // pagination: {
                  //   el: ".swiper-pagination",
                  //   clickable: true,
                  // },
                  // navigation: {
                  //   nextEl: ".swiper-button-next",
                  //   prevEl: ".swiper-button-prev",
                  // },
                  autoHeight: true,
                  centeredSlides: true,
                  slidesPerView: "auto",
                  speed: 500,
                  roundLengths: true,
                  observer: true,
                  observeParents: true,
                  observeSlideChildren: true,
                  calculateHeight: true,
                };
              } else {
                console.log("电脑");
                nowHeight = (($(".container").width() * 0.35) / 680) * 335;
                isMobile= false
                swiper5Option = {
                  loop: true,
                  autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                  },
                  spaceBetween: 50,
                  slidesPerView: 3,
                  autoHeight: true,
                  centeredSlides: true,
                };
              }
              that.swiper3 = new Swiper(".swiper3", {
                loop: true,
                speed: 4000,
                allowTouchMove: !isMobile,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                },
                mousewheel: true,
                spaceBetween: 30,
                height: nowHeight,
                direction: "vertical",
                autoHeight: true,
                centeredSlides: true,
                slidesPerView: 1,
              });
              that.swiper4 = new Swiper(".swiper4", {
                loop: true,
                speed: 4000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                },
                allowTouchMove: !isMobile,
                mousewheel: true,
                spaceBetween: 30,
                direction: "vertical",
                height: nowHeight,
                autoHeight: true,
                centeredSlides: true,
                slidesPerView: 1,
              });
              that.swiper5 = new Swiper(".swiper5", swiper5Option);
              
            });
          });
        });
      }
    });
    window.addEventListener("scroll", this.handleScrollx, true);
    window.scroll(function() {
      var pagetop = $(window).scrollTop();
    });
  },
};
</script>

<style lang="scss">
.container {
  @media (max-width: 768px) {
    width: 90% !important;
  }
}

.content_index {
  @media (max-width: 768px) {
    .tips4 {
      .container {
        width: 100% !important;
      }
      .custom-title {
        margin-left: 5% !important;
      }
      .swiper-wrapper {
        width: 100%;
        .swiper-slide {
          width: 80%;
          overflow: hidden;
          margin: 0 1%;
          img {
            opacity: 0.9;
          }
          &:hover {
            img {
              opacity: 1;
            }
          }
        }
      }
    }
    .swiper6 {
      .swiper-slide {
        // width: 30% !important;
      }
    }
  }
  .kv_box {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .kv {
    width: 100%;
    overflow: hidden;
    .swiper-button-prev {
      left: 10%;
      @media (max-width: 768px) {
        left: 5%;
      }
    }
    .swiper-button-next {
      right: 10%;

      @media (max-width: 768px) {
        right: 5%;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      z-index: 999;
      position: absolute;
      top: calc(50% - 35px);
      z-index: 9;
      border: solid 3px rgba(255, 255, 255, 0.8);
      width: 70px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      border-radius: 50%;
      @media (max-width: 768px) {
        width: 30px;
        height: 30px;
        line-height: 30px;
        top: 50%;
      }
    }
    .swiper-button-prev::after {
      content: "prev" !important;
      font-family: "swiper-icons";
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    .swiper-button-next::after {
      content: "next" !important;
      font-family: "swiper-icons";
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      // @media (max-width: 768px) {
      //   height: 212px;
      // }
      .swiper-wrapper {
        width: 100%;
        height: 100%;
        .swiper-slide {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .text_des {
            position: absolute;
            text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.5);
            left: calc(15% + 40px);
            top: calc(50% - 140px);
            font-size: 48px;
            color: #fff;
            line-height: 1.5;
            @media (max-width: 768px) {
              font-size: 16px;
              left: calc(25%);
              top: 35%;
              line-height: 20px;
            }
          }
          .btn_contact {
            width: 200px;
            height: 50px;
            margin-top: 30px;
            display: block;
            font-size: 24px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            border: solid 1px rgba(255, 255, 255, 0.4);
            @media (max-width: 768px) {
              width: 67px;
              height: 17px;
              font-size: 9px;
              // line-height: 17px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          img {
            transition: 1s linear 0.5;
            transform: scale(1.1, 1.1);
            width: 100%;
            height: calc(100vh - 120px);
            max-height: 1080px;
            object-fit: cover;
          }
          &.swiper-slide-active {
            img {
              transition: 2s linear;
              transform: scale(1, 1);
              width: 100%;
              height: calc(100vh - 120px);
              max-height: 1080px;
              object-fit: cover;
            }
          }
        }
      }
      .swiper-pagination {
        text-align: left;
        bottom: 3%;
        left: 0%;
        text-align: center;

        span {
          width: 8px;
          height: 8px;
          opacity: 1;
          background: rgba(191, 205, 221, 0.3);
          &.swiper-pagination-bullet-active {
            background: rgba(191, 205, 221, 0.8);
          }
        }
      }

      .w100 {
        img {
          position: relative;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .tips2 {
    position: relative;
    background: url("../../assets/images/index/tips2_bg2.jpg") no-repeat center;
    background-size: cover;
    background-attachment: fixed;
    .container {
      width: 72.9%;
      position: relative;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      margin: auto;
      padding: 4% 0;
      display: flex;
      align-items: end;
      justify-content: space-between;flex-wrap: wrap;
      @media (max-width: 1024px) {
        width: 84%;
      }
    }
    .text_box {
      width: 53%;
      @media (max-width: 768px) {
        width: 100%;
      }  
      h3 {
        font-size: 43px;
        color: #ad1f24;
        position: relative;
        line-height: 1.8;
        display: inline-block;
        &::after {
          content: "";
          border-bottom: solid 4px #ad1f24;
          width: 120px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &:hover {
          &::after {
            width: 100%;
          }
        }
      }
      p {
        font-size: 16px;
        color: #444;
        line-height: 1.7;
        margin-top: 30px;
        @media (max-width: 1600px) {
          font-size: 14px;
          line-height: 1.6;
        }
        @media (max-width: 768px) {
          margin-top: 15px;
          font-size: 12px;
          line-height: 18px;
        }
      }
      ul {
        display: flex;
        justify-content: space-between;
        li {
          width: 32%;
          text-align: center;
          border: solid 1px #eee;
          padding: 1% 0;
          @media (max-width: 768px) {
            border: 0 !important;
            padding: 13px 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            flex-direction: column-reverse;
            p {
              margin-bottom: 0 !important;
              // margin-top: 10px !important;
              font-size: 12px !important;
            }
          }
          p {
            margin-top: 0;margin-bottom: 6px;
            white-space: nowrap;
            color: #444;
            width: 100%;
          }
          font-size: 16px;
          color: #444;
          span {
            font-size: 26px;
            color: #ad1f24;
            @media (max-width: 768px) {
              // margin-top: 15px;
              font-size: 18px;
              line-height: 18px;
              font-weight: bold;
            }
          }
          &:hover {
            color: #fff;
            background: #ad1f24;
            p {
              color: #fff;
            }
            span {
              color: #fff;
            }
          }
        }
      }
    }
    .video{width: 45%;
        @media (max-width: 768px) {
          width: 100%;
        }  
    }
  }
  .tips3 {
    background: #ad1f24;
    padding: 5vw 0;

    .container {
      @media (max-width: 768px) {
        width: 90% !important;
      }
    }
    h3 {
      font-size: 43px;
      margin-bottom: 2.5vw;
      color: #fff;
      position: relative;
      line-height: 1.8;
      display: inline-block;
      @media (max-width: 768px) {
        font-size: 30px;
      }
      &::after {
        content: "";
        border-bottom: solid 4px #fff;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &:hover {
        &::after {
          width: 100%;
        }
      }
    }
    .tips3List {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 24%;
        @media (max-width: 768px) {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          width: 48%;
          margin-bottom: 10px !important;
          img {
            width: 100% !important;
            height: 120px !important;
          }
          .text_bottom {
            width: 100% !important;
            height: 55px !important;
            padding: 5px !important;
            h4 {
              font-size: 12px !important;
              line-height: 15px !important;
              margin-bottom: 0 !important;
            }
            p {
              font-size: 12px !important;
              line-height: 15px !important;
              height: auto !important;
            }
          }
        }
        margin-bottom: 60px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .text_bottom {
          background: #fff;
          padding: 28px;
          position: relative;
          .tips3_text {
            h4 {
              font-size: 24px;
              color: #000;
              line-height: 1.5;
              margin-bottom: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              font-size: 14px;
              color: #666;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 40px;
              line-height: 20px;
            }
            @media (max-width: 1440px) {
              h4 {
                font-size: 20px;
              }
              p {
                font-size: 13px;
                color: #666;
                line-height: 20px;
                // overflow: visible;
                // text-overflow: initial;
                // -webkit-box-orient: inline-axis;
                word-wrap: break-word;
              }
            }
          }
          .buttom {
            display: flex;
            cursor: pointer;
            @media (max-width: 768px) {
              display: none;
            }
            span {
              line-height: 26px;
              color: #ad1f24;
              border: solid 2px #ad1f24;
              display: inline-block;
              padding: 0 14px;
              margin-left: 4px;
            }
            &:hover {
              span {
                background: #ad1f24;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
  .tips_boxz {
    background: url("../../assets/images/index/tips7_bg.webp") no-repeat center;
    background-attachment: fixed;
    background-size: cover;
  }
  .tips4 {
    padding: 6vw 0;
    .container {
      width: 72.9%;
      position: relative;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      @media (max-width: 768px) {
        padding: 0 0;
      }
      @media (max-width: 1024px) {
        width: 90%;
      }
    }
    .text_box {
      width: 100%;
      h3 {
        font-size: 43px;
        color: #ad1f24;
        position: relative;
        line-height: 1.8;
        display: inline-block;
        @media (max-width: 768px) {
          font-size: 30px;
        }
        &::after {
          content: "";
          border-bottom: solid 4px #ad1f24;
          width: 120px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &:hover {
          &::after {
            width: 100%;
          }
        }
      }
      .swiper5 {
        .swiper-slide {
          text-align: center;
          padding-top: 60px;
          width: 60%;
          @media (max-width: 768px) {
            padding-top: 30px;
          }
          // @media (max-width: 1024px) {
          //   margin-right: 30px;
          // }
          p {
            height: 70px;
            line-height: 70px;
            text-align: center;
            font-size: 24px;
            color: #fff;
            background: #ad1f24;
            @media (max-width: 768px) {
              height: 30px;
              width: 100%;
              line-height: 30px;
              font-size: 14px;
            }
          }

          &:hover {
            p {
              color: #ad1f24;
              background: #fff;
              height: 70px;
              box-shadow: 5px 0 27px #ccc;
              @media (max-width: 768px) {
                height: 30px;
                width: 100%;
                line-height: 30px;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

  .tips5 {
    background: url("../../assets/images/index/tips8_bg.jpg") no-repeat center
      right;
    background-size: cover;
    padding: 6vw 0;
    .container {
      @media (max-width: 768px) {
        width: 90%;
      }
    }
    .top-text {
      display: none;
    }
    @media (max-width: 768px) {
      .top-text {
        display: block;
        margin-bottom: 10px !important;
      }
      .bottom-text {
        display: none;
      }
      .swiper-wrapper {
        // height: 200px !important;
        .swiper-slide {
          // height: 80% !important;
        }
      }
    }
    h3 {
      font-size: 43px;
      margin-bottom: 2.5vw;
      display: inline-block;
      color: #ad1f24;
      position: relative;
      line-height: 1.8;
      @media (max-width: 768px) {
        font-size: 30px;
      }
      &::after {
        content: "";
        border-bottom: solid 4px #ad1f24;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &:hover {
        &::after {
          width: 100%;
        }
      }
    }
    .img_box {
      display: flex;
      justify-content: space-between;
      align-items: end;
      .tips5_1 {
        @media (max-width: 768px) {
          display: none;
        }
        width: 25%;
        overflow: hidden;
        p {
          line-height: 2;
          color: #ad1f24;
          font-size: 16px;
          margin: 20px 0;
          a {
            color: #ad1f24;
          }
          a:hover {
            color: #ad1f24;
          }
        }

        .btn_contact {
          height: 40px;
          margin: 30px 0 0;
          display: block;
          border-radius: 5px;
          width: 80%;
          font-size: 20px;
          text-align: center;
          line-height: 40px;
          color: #fff;
          background: #ad1f24;
          &:hover {
            background: #cfa000;
          }
        }
      }
      .tips5_2 {
        width: 74%;
        display: flex;
        justify-content: space-between;
        @media (max-width: 768px) {
          width: 100%;
          flex-wrap: wrap;
        }
        .top-text {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .tips5_img {
        position: relative;
        width: 49%;

        @media (max-width: 768px) {
          width: 100%;
          flex-wrap: wrap;
          img {
            height: 200px !important;
          }
        }
        p {
          font-size: 24px;
          color: #333;
          margin-top: 10px;
          position: relative;
          z-index: 9;
          margin-bottom: 0;
        }
        img {
          width: 100%;
          height: inherit;
        }
      }
    }
  }
  .tips7 {
    background: #ad1f24;
    padding: 6vw 0;
    position: relative;
    overflow: hidden;
    @media (max-width: 768px) {
      padding: 10px 0;
      .container {
        width: 100% !important;
      }
      .custom-title {
        margin-left: 5% !important;
      }
      p {
        width: 90% !important;
        margin-left: 5% !important;
      }
      .tips7-img {
        // width: 42px !important;
        // height: 94px !important;
      }

      p {
        word-wrap: break-word !important;
        font-size: 12px !important;
        line-height: 18px !important;
      }
    }
    .swiper-button-prev {
      left: 7%;
      @media (max-width: 768px) {
        top: 65% !important;
        left: 2%;
      }
    }
    .swiper-button-next {
      right: 7%;
      @media (max-width: 768px) {
        top: 65% !important;
        right: 2%;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      z-index: 999;
      position: absolute;
      top: calc(63% - 35px);
      z-index: 9;
      border: solid 3px rgba(255, 255, 255, 0.8);
      width: 70px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      border-radius: 50%;
      @media (max-width: 768px) {
        display: none;
      }
    }
    .swiper-button-prev::after {
      content: "prev" !important;
      font-family: "swiper-icons";
    }
    .swiper-button-next::after {
      content: "next" !important;
      font-family: "swiper-icons";
    }

    h3 {
      font-size: 43px;
      margin-bottom: 2.5vw;
      display: inline-block;
      color: #fff;
      position: relative;
      line-height: 1.8;
      &::after {
        content: "";
        border-bottom: solid 4px #fff;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &:hover {
        &::after {
          width: 100%;
        }
      }
    }
    p {
      font-size: 16px;
      line-height: 2;
      color: #fff;
      margin-bottom: 3vw;
    }
    .lear_more {
      display: inline-block;
      width: 160px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 20px;
      color: #fff;
      background: #cfa000;
      border-radius: 5px;
      margin-top: 3vw;
      float: right;
      @media (max-width: 768px) {
        width: calc(178px / 2);
        height: 17px;
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
  .tips6 {
    position: relative;
    @media (max-width: 768px) {
      height: 550px;

      li {
        margin-top: 20px !important;
      }
    }

    .container {
      width: 72.9%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      @media (max-width: 1024px) {
        width: 90%;
      }
    }
    .text_box {
      width: 100%;

      h3 {
        font-size: 43px;
        color: #ad1f24;
        position: relative;
        line-height: 1.8;
        display: inline-block;
        @media (max-width: 768px) {
          font-size: 30px;
        }
        &::after {
          content: "";
          border-bottom: solid 4px #ad1f24;
          width: 120px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        &:hover {
          &::after {
            width: 100%;
          }
        }
      }
      ul {
        display: flex;
        justify-content: space-between;
        @media (max-width: 768px) {
          flex-wrap: wrap;
        }
        li {
          @media (max-width: 768px) {
            display: flex;
            width: 100%;
            background: rgba(0, 0, 0, 0);
            img {
              // width: 47px !important;
              height: 58px !important;
              margin-right: 20px !important;
            }
            div {
              width: calc(100% - 47px) !important;
              h4 {
                text-align: left !important;
                font-size: 18px !important;
              }
              p {
                font-size: 12px !important;
                line-height: 18px !important;
              }
            }
          }
          width: 32%;
          text-align: center;
          margin-top: 60px;
          cursor: pointer;
          padding-right: 1%;
          background: url("../../assets/images/index/line.png") no-repeat center
            right;
          &:last-child {
            background: none;
            padding-right: 0;
          }
          img {
            height: 115px;
            width: auto;
            margin: auto;
          }
          h4 {
            font-size: 24px;
            color: #000;
            margin: 30px auto 15px;
          }
          p {
            line-height: 20px;
            font-size: 14px;
            text-align: left;
            color: #666;
          }
          &:hover {
            img {
              animation: jump 0.5s ease-in-out infinite;
            }
          }
        }
      }
    }
  }
  h3 {
    font-size: 36px;
    color: #000;
  }
}
</style>
